import React from 'react';
import SideBar from '../components/dashboard/Sidebar';
import Header from '../components/dashboard/Header';
import Home from '../components/dashboard/Home';
import JobList from '../components/dashboard/JobList';
import Profile from '../components/dashboard/Profile';
import Password from '../components/dashboard/Password';
import Form from '../components/dashboard/Form';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';


function Dashboard(props) {
    return (
        <>
            {
                Cookies.get('token') ?
                    <main className="bg-slate-100 dark:bg-gray-800 relative">
                        <div className="flex items-start justify-between">
                            {props.Home && <SideBar Home />}
                            {props.JobList && <SideBar JobList />}
                            {props.Profile && <SideBar Profile />}
                            {props.Post && <SideBar Post />}
                            {props.Password && <SideBar Password />}
                            {props.Logout && <SideBar Logout />}
                            <div className="flex flex-col w-full md:space-y-10 mb-10">
                                <Header />
                                {props.Home && <Home />}
                                {props.JobList && <JobList />}
                                {props.Profile && <Profile />}
                                {props.Password && <Password />}
                                {props.Post && <Form />}
                            </div>
                        </div>
                    </main>
                    :
                    <Navigate to={'/login'} />
            }

        </>
    );
}

export default Dashboard;